export default __webpack_public_path__ + "e5a664fbc3693f895dd2fe4c27058a8f.png";